import { Button, Chat3LineIcon } from 'ui';

type P = {
  onShowComments?: () => void;
};

const CommentButton = ({ onShowComments }: P) => (
  <Button icon={<Chat3LineIcon />} onClick={onShowComments} size="large" type="text">
    Comment
  </Button>
);

export default CommentButton;
